import(/* webpackMode: "eager" */ "/vercel/path0/images/covers/forever.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/images/covers/la.png");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
